<template>
  <div class="musiclibrary mp3-playlists container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">
                  Meditation Library
                </h4>
              </div>
            </div>
          </div>
          <b-card no-body id="musicLibraryMp3Card" class="p-3">
            <b-card-body class="pt-md-0 p-0 pt-1 pt-md-1">
              <div class="row mb-2 px-2">
                <div
                  class="
                    col-xl-3
                    offset-xl-9
                    col-md-3
                    offset-md-9
                    px-md-0 px-3
                    addButtonContainerDiv
                  "
                >
                  <b-button
                    variant="doomyoga-primary"
                    id=""
                    class="btn btn-filter m-0 btn-lg-doomyoga w-100 float-right"
                    @click="clickAddAudio"
                  >
                    + Add New
                  </b-button>
                  <SaveAudio
                    type="meditation_library"
                    sub_type="audio"
                    :action_type="save_audio_action_type"
                    :playlist="selected_category"
                    :playlist_list="category_list_select"
                    :id="selected_audio_id"
                    :audio_title="selected_audio_title"
                    :audio_description="selected_audio_description"
                    :created_by="selected_audio_created_by"
                    :time_duration="selected_audio_time_duration"
                    :audio_id="selected_audio_media_id"
                    :image_id="selected_audio_cover_id"
                    :media_obj="media_obj"
                    :cover_obj="cover_obj"
                  />
                </div>
              </div>

              <!-- <dataset
                v-slot="{ ds }"
                :ds-data="tracks"
                :ds-filter-fields="{
                  title: startsWithFilter,
                }"
                :ds-search-in="['title', 'album']"
                :ds-search-as="{ searchTest }"
              >
                <div class="row mb-2" :data-page-count="ds.dsPagecount">
                  <div class="col-xl-6 col-md-6">
                    <b-input-group
                      class="input-group-search input-group-search-doomyoga"
                    >
                      <template #prepend>
                        <font-awesome-icon
                          icon="fa-solid fa-magnifying-glass"
                          size="lg"
                        />
                      </template>
                      <dataset-search
                        ds-search-placeholder="Search"
                        class="form-control-doomyoga"
                    /></b-input-group>
                  </div>
                  <div
                    class="col-xl-3 col-md-3 px-md-0 px-3 addButtonContainerDiv"
                  >
                    <b-button
                      variant="doomyoga-primary"
                      id=""
                      class="btn btn-filter m-0 btn-lg-doomyoga"
                      v-b-modal.saveAudioModal
                    >
                      + Add New
                    </b-button>
                    <SaveAudio
                      type="meditation_library"
                      :playlist="selected_category"
                      :playlist_list="category_list_select"
                    />
                  </div>
                  <div class="col-xl-3 col-md-3 pr-md-0">
                    <dataset-show
                      :ds-show-entries="5"
                      class="
                        showEntriesSelectContainer
                        show-entries-doomyoga
                        float-right
                      "
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="row my-2">
                      <div class="col">
                        <h3
                          class="
                            media-category-title media-category-title-doom-yoga
                          "
                        >
                          {{ title }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive" style="max-height: 450px">
                      <table class="table doomYogaTable doomYogaPlaylistTable">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th>Title</th>
                            <th>Category</th>
                            <th>Duration</th>
                          </tr>
                        </thead>
                        <dataset-item tag="tbody">
                          <template #default="{ row, rowIndex }">
                            <tr>
                              <td scope="row">{{ rowIndex + 1 }}</td>
                              <td>
                                <img
                                  v-if="row.cover_image == null"
                                  src="@/assets/images/doom-yoga/doomyoga-music.png"
                                />
                                <img v-else :src="row.cover_image" />
                                {{ row.title }}
                              </td>
                              <td>{{ title }}</td>
                              <td>{{ row.time_duration }}</td>
                            </tr>
                          </template>
                          <template #noDataFound>
                            <tr>
                              <td colspan="4">
                                <p
                                  class="
                                    text-center
                                    datasetNoFoundP
                                    noDataFoundDY
                                    mb-0
                                  "
                                >
                                  No data found
                                </p>
                              </td>
                            </tr>
                          </template>
                        </dataset-item>
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  class="
                    d-flex
                    flex-md-row flex-column
                    justify-content-between
                    align-items-center
                  "
                >
                  <dataset-info
                    class="mb-2 mb-md-0 datasetInfo datasetInfoDY"
                  />
                  <dataset-pager class="datasetPagerDY" />
                </div>
              </dataset> -->

              <AudioPlaylistPlayer
                v-if="tracks.length > 0"
                client_name="DY"
                :playlist_title="title"
                :tracks="tracks"
                :media_type="media_library"
              />

              <dataset
                v-else
                :ds-data="tracks"
                :ds-filter-fields="{
                  title: startsWithFilter,
                }"
                :ds-search-in="['title', 'album']"
                :ds-search-as="{ searchTest }"
              >
                <div class="row">
                  <div class="col-md-12">
                    <div class="row my-2">
                      <div class="col">
                        <h3
                          class="
                            media-category-title media-category-title-doom-yoga
                          "
                        >
                          {{ title }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive" style="max-height: 450px">
                      <table class="table doomYogaTable doomYogaPlaylistTable">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th>Title</th>
                            <th>Category</th>
                            <th>Duration</th>
                          </tr>
                        </thead>
                        <dataset-item tag="tbody">
                          <template #default="{ row, rowIndex }">
                            <tr>
                              <td scope="row">{{ rowIndex + 1 }}</td>
                              <td>
                                <img
                                  v-if="row.cover_image == null"
                                  src="@/assets/images/doom-yoga/doomyoga-music.png"
                                />
                                <img v-else :src="row.cover_image" />
                                {{ row.title }}
                              </td>
                              <td>{{ title }}</td>
                              <td>{{ row.time_duration }}</td>
                            </tr>
                          </template>
                          <template #noDataFound>
                            <tr>
                              <td colspan="4">
                                <p
                                  class="
                                    text-center
                                    datasetNoFoundP
                                    noDataFoundDY
                                    mb-0
                                  "
                                >
                                  No data found
                                </p>
                              </td>
                            </tr>
                          </template>
                        </dataset-item>
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  class="
                    d-none
                    flex-md-row flex-column
                    justify-content-between
                    align-items-center
                  "
                >
                  <dataset-info
                    class="mb-2 mb-md-0 datasetInfo datasetInfoDY"
                  />
                  <dataset-pager class="datasetPagerDY" />
                </div>
              </dataset>

              <div class="row mb-5" v-if="category_list.length > 0">
                <div class="col-md-12">
                  <div class="row my-2">
                    <div class="col">
                      <h3
                        class="
                          media-category-title media-category-title-doom-yoga
                          mb-0
                        "
                      >
                        Other Audio Meditations
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col">
                      <VueSlickCarousel
                        v-if="category_list != null && category_list.length > 0"
                        v-bind="settings_slick"
                        class="slick-slider-doom-yoga"
                      >
                        <template #prevArrow>
                          <div class="custom-arrow">
                            <img
                              src="@/assets/images/doom-yoga/arrow-left-active.png"
                            />
                          </div>
                        </template>
                        <div
                          v-for="item in category_list.filter(
                            (v) => v.library_media.length > 0
                          )"
                          :key="item.id"
                          class=""
                        >
                          <router-link
                            :to="
                              '/doom_yoga/meditation_library/audio_category/' +
                              item.id
                            "
                            class="card-link eventLink"
                          >
                            <MediaGallery
                              :title="item.title"
                              :videos="item.library_media"
                              media_type="audio"
                            />
                          </router-link>
                        </div>
                        <template #nextArrow>
                          <div class="custom-arrow">
                            <img
                              src="@/assets/images/doom-yoga/arrow-right-active.png"
                            />
                          </div>
                        </template>
                      </VueSlickCarousel>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import MediaCard from "../media/MediaCard.vue";
import AddMediaCard from "../media/AddMediaCard.vue";
import SaveAudio from "../media/SaveAudio.vue";
import MediaGallery from "../media/MediaGallery.vue";
import AudioPlaylistPlayer from "@/components/media_components/AudioPlaylistPlayerAdmin.vue";
import { formatBytes } from "@/utils/helper-functions.js";

import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce, fieldFilter, findAny } from "vue-dataset/src/helpers";

export default {
  name: "MP3PlaylistTracks",
  components: {
    MediaCard,
    AddMediaCard,
    MediaGallery,
    SaveAudio,
    AudioPlaylistPlayer,
  },
  data() {
    return {
      datasetI18n: {
        show: "Show",
        entries: "entries",
        previous: "Previous",
        next: "Next",
        showing: "Showing",
        showingTo: "to",
        showingOf: "of",
        showingEntries: "entries",
      },
      settings_slick: {
        dots: false,
        arrows: true,

        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
          //col-xl-2 col-lg-3 col-md-3 col-6
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      id: null,
      title: "",
      tracks: [],

      category_list: [],
      category_list_select: [],
      selected_category: null,

      onlineFilter: "",
      selected: 5,
      startsWith: "",
      playlist_title: null,
      playlist_url: null,
      playlist_cover_image: null,
      media_library: "meditation_library",

      save_audio_action_type: "add",
      selected_audio_id: null,
      selected_audio_title: null,
      selected_audio_description: null,
      selected_audio_created_by: null,
      selected_audio_time_duration: null,
      selected_audio_media_id: null,
      selected_audio_cover_id: null,
      media_obj: null,
      cover_obj: null,
    };
  },
  mounted() {
    this.selected_category = [Number(this.$route.params.id)];
    this.id = this.$route.params.id;

    this.getOpenCategoryAudiosList();
    this.getMediaCategoryList();
  },
  computed: {},
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  methods: {
    formatBytes,
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    // updateData() {
    //   const updatedList = clone(tracks).slice(5, 5);
    //   this.tracks = updatedList;
    // },
    startsWithFilter(value) {
      return (
        value === null ||
        value.toLowerCase().startsWith(this.startsWith.toLowerCase())
      );
    },
    searchTest(value, searchString, rowData) {
      console.log(value);
      console.log(searchString);
      console.log(rowData);
      console.log(searchString === value);
      return searchString === value;
    },
    fieldFilter,
    getOpenCategoryAudiosList() {
      axios
        .get("/media/library/category/" + this.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.library_media);
          console.log(response.data.library_media.length);
          this.title = response.data.title;
          this.tracks = response.data.library_media;

          // this.tracks = this.tracks.concat(response.data.library_media);
          // this.tracks = this.tracks.concat(response.data.library_media);
          // this.tracks = this.tracks.concat(response.data.library_media);
          // this.tracks = this.tracks.concat(response.data.library_media);
        });
    },
    getMediaCategoryList() {
      console.log("in get categories");
      // this.category_list = [];
      let formData = new FormData();
      formData.append("media_library", this.media_library);
      formData.append("sub_library", "audio");
      axios
        .post("media/library/categories", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          console.log(response.data.slice(0));
          this.category_list = response.data;
          this.category_list_select = response.data.slice(0);
          this.category_list_select.push({ title: "New category", id: "new" });
          console.log(this.category);
        });
    },
    clickAddAudio() {
      console.log("click add audio ");

      this.save_audio_action_type = "add";
      this.selected_audio_id = null;
      this.selected_audio_title = null;
      this.selected_audio_description = null;
      this.selected_audio_created_by = null;
      this.selected_audio_time_duration = null;
      this.selected_audio_media_id = null;
      this.selected_audio_cover_id = null;
      this.selected_category = [Number(this.$route.params.id)];

      this.media_obj = null;
      this.cover_obj = null;

      this.$root.$emit("bv::show::modal", "saveAudioModal");
    },
    clickEditAudio(media) {
      console.log("in click edit audio", media.id);
      console.log(media);

      this.save_audio_action_type = "edit";
      this.selected_audio_id = media.id;
      this.selected_audio_title = media.title;
      this.selected_audio_description =
        media.description == "N/A" || media.description == "null"
          ? null
          : media.description;
      this.selected_audio_created_by = media.created_by;
      this.selected_audio_time_duration = media.time_duration;
      this.selected_audio_media_id = media.media.id;
      this.selected_audio_cover_id = media.cover_image.id;
      this.selected_category = media.category_ids;
      console.log(this.formatBytes(media.media.size));
      this.media_obj = [
        {
          name: "" + media.title + ".mp4",
          lastModified: 1576563996233,
          sizeText: this.formatBytes(media.media.size),
          size: media.media.size,
          type: media.media.type,
          ext: media.media.extension,
          dimensions: {
            width: "",
            height: "",
          },
          url: "" + media.media.full_path,
          imageColor: [33, 33, 33],
        },
      ];
      this.cover_obj = [
        {
          name: "" + media.title + "." + media.cover_image.extension,
          lastModified: 1576563996233,
          sizeText: this.formatBytes(media.cover_image.size),
          size: media.cover_image.size,
          type: media.cover_image.type,
          ext: media.cover_image.extension,
          dimensions: {
            width: "",
            height: "",
          },
          url: "" + media.cover_image.full_path,
          imageColor: [33, 33, 33],
        },
      ];

      this.$root.$emit("bv::show::modal", "saveAudioModal");
    },
  },
};
</script>

<style scoped::v-deep >
@import "../css/doom-yoga-audio-player-styles.css";
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/meditation_library/AudioCategoryTracks.vue